// ownerResolution.js
// Pure logic for resolving the list of owner names to show in a
// dropdown: live directory first, static fallback list second.
// Extracted so the fallback branch has direct test coverage instead of
// being an inline, unexercised assumption (only fires when Graph fails).
export function resolveOwnerNames(orgUsers, fallbackNames) {
  if (orgUsers && orgUsers.length > 0) {
    const names = orgUsers.map(function (u) { return u.displayName; }).filter(Boolean);
    if (names.length > 0) return names;
  }
  return fallbackNames;
}
